import React, { Component } from "react";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from "toastr";
import { Link } from "react-router-dom";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import { NotificationContainer, NotificationManager } from "react-notifications";
import {
  Dropdown,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  TabContent,
  Nav,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FiPlusCircle, FiMinusCircle, FiCopy } from "react-icons/fi";
import { Validation } from "app/_helpers/validation/Validation";
import { StateService } from "app/_services/ConfigService/StateService/StateService";
import { Constant } from "./Constant";
import { MasterService } from "app/_services/MasterService/MasterService";
import Prompt from "app/Components/IEnergyPrompt/Prompt";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { IoIosArrowBack } from "react-icons/io";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";

class AddState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      status: "",
      error: {},
      stateId: this.props.match.params.id ? this.props.match.params.id : "",
      // projectId: this.props.match.params.projectId ? this.props.match.params.projectId : "",
      // projectData: {},
      submitted: false,
      edit: false,
      countryMasterId: "",
      countryArr: [],
      changeRoute: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    // if (this.state.projectId) {
    // this.setProjectDetails();
    this.getCountryMaster(this.state.projectId);

    if (this.state.stateId) {
      this.setStateData(this.state.stateId);
      this.setState({
        edit: true,
      });
    }
    // } else {
    //     NotificationManager.info('No Record Found')
    //     this.props.history.push('/');
    // }
  }

  async getCountryMaster(projectId) {
    let response = await MasterService.getCountryByProjectID(projectId);
    if (response && response.status) {
      if (response.data && response.data) {
        this.setState({
          countryArr: response.data.countryMaster,
        });

        // if (response.data.countryMaster && response.data.countryMaster.length === 1) {
        //     this.setState({
        //         countryId: response.data.countryMaster[0].id
        //     }, () => {
        //         this.getStateByCountryID(this.props.projectId, this.state.countryId)
        //     })
        // }
      }
    }
  }
  async setStateData(stateId) {
    let response = await StateService.getStateByID(this.state.projectId, stateId);

    if (response && response.status) {
      if (response.data && response.data) {
        let stateData = response.data;
        this.setState({
          stateData: stateData,
          name: stateData.name,
          status: stateData.activeStatus,
          countryMasterId: stateData.countryMasterId,
        });
      }
    } else {
      NotificationManager.info("No Record Found");
      this.props.history.push("/");
    }
  }

  // async setProjectDetails() {
  //     let response = await ProjectService.projectDetailsByID(this.state.projectId);

  //     if (response && response.status) {
  //         if (response.data && response.data) {
  //             this.setState({
  //                 projectData: response.data
  //             })
  //         }
  //     } else {
  //         NotificationManager.info('No Record Found')
  //         this.props.history.push('/');
  //     }
  // }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState(
      {
        [name]: value,
      },
      () => {
        this.checkValidation();
        console.log("state", this.state);
      }
    );
  };

  /**********************Validation ***************/
  checkValidation() {
    this.setState({
      changeRoute: 1,
    });
    if (this.state.submitted) {
      var errobj = {};

      /**call validation file for validation */
      errobj = Validation(this.state, Constant.stateCustomField);

      this.setState({ error: errobj, submitted: true });
    }
  }

  async onSubmit(e) {
    e.preventDefault();

    var errobj = {};

    /**call validation file for validation */
    errobj = Validation(this.state, Constant.stateCustomField);

    this.setState({ error: errobj, submitted: true });
    /**
     * final checking for any error exists or not
     */
    var flag = 0;
    Object.keys(errobj).map((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    console.log("flag", flag);
    if (flag === 0) {
      let obj = {
        name: this.state.name,
        activeStatus: this.state.status,
        project_id: this.state.projectId,
        countryMasterId: this.state.countryMasterId,
      };

      let data = {};

      if (this.state.edit) {
        data = await StateService.updateState(
          this.state.projectId,
          this.state.stateId,
          obj
        );
      } else {
        data = await StateService.createState(this.state.projectId, obj);
      }

      if (data && data.status === 1) {
        this.setState({
          changeRoute: "",
        });
        if (this.state.edit) {
          toastr.info("State Updated");
          //NotificationManager.success('State Updated')
          this.props.history.push("/global-configuration/project-details/state");
        } else {
          toastr.info("State Created");
          //NotificationManager.success('State Created')
          this.props.history.push("/global-configuration/project-details/state");
        }
      } else if (data && data.message) {
        toastr.warning(data.message);
      }
    }
  }

  render() {
    const {
      name,
      status,
      projectData,
      projectId,
      edit,
      error,
      submitted,
      countryArr,
      countryMasterId,
    } = this.state;
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            // { name: this.state.projectData.name, path: "/project/" + this.state.projectId + "/dashboard" },
            // { name: "Configuration", path: "#" },
            { name: "Global Settings", path: "#" },
            { name: "State", path: "/global-configuration/project-details/state" },
            { name: edit ? "Edit" : "Add" },
          ]}
          // imageSrc={projectData && projectData.document && projectData.document.document_name ? projectData.document.document_name : ''}
          // description={projectData && projectData.descriptionDisplay ? projectData.descriptionDisplay : ''}
          breadCrumbsText="Configuration_Project_Details_State"
        />
        <Prompt changes={this.state.changeRoute}></Prompt>
        <div className="row d-flex justify-content-center">
          <div className="col-md-5">
            <div className="card mt-4 mb-3">
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">{edit ? "Edit" : "Add"} State</h3>
                </div>
                <form onSubmit={this.onSubmit}>
                  <div className="row">
                    <div className="col-md-12 form-group mb-3">
                      <label>Country</label>
                      {/* <select
                                                name="countryMasterId"
                                                className="form-control customSelect"
                                                onChange={e => this.handleInputChange(e)}
                                                value={countryMasterId}
                                            >
                                                <option value=''>Select</option>
                                                {countryArr && countryArr.length > 0 ?
                                                    countryArr.map((data, index) => {
                                                        return <option
                                                            key={index}
                                                            value={data.id}
                                                        >{data.name}</option>
                                                    })
                                                    : ''
                                                }
                                            </select> */}
                      <SimpleSelect
                        name="countryMasterId"
                        className="form-control customSelect"
                        onChange={(e) => this.handleInputChange(e)}
                        value={countryMasterId}
                        id="id"
                        label="name"
                        options={countryArr}
                        init="Select"
                      ></SimpleSelect>

                      {submitted && error.countryMasterId !== "" && (
                        <div className="fromerror">{error.countryMasterId}</div>
                      )}
                    </div>
                    <div className="col-md-12 form-group mb-3">
                      <label>State</label>
                      <input
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="Enter State Name"
                        value={name}
                        onChange={(e) => this.handleInputChange(e)}
                      />
                      {submitted && error.name !== "" && (
                        <div className="fromerror">{error.name}</div>
                      )}
                    </div>

                    <div className="col-md-12 form-group mb-3">
                      <label>Status</label>
                      {/* <select
                                                name="status"
                                                className="form-control"
                                                value={status}
                                                onChange={e => this.handleInputChange(e)}
                                            >
                                                <option value="">Select Status</option>
                                                <option value={1}>Active</option>
                                                <option value={2}>In-active</option>
                                            </select> */}

                      <SimpleSelect
                        name="status"
                        className="form-control"
                        value={status}
                        onChange={(e) => this.handleInputChange(e)}
                        id="id"
                        label="name"
                        options={[
                          { id: 1, name: "Active" },
                          { id: 2, name: "In-active" },
                        ]}
                        init="Select Status"
                      ></SimpleSelect>

                      {submitted && error.status !== "" && (
                        <div className="fromerror">{error.status}</div>
                      )}
                    </div>
                    <div className="col-md-12"></div>
                    <div className="col-md-12 text-center">
                      <Link
                        to={"/global-configuration/project-details/state"}
                        className="btn btn-secondary mr-2"
                      >
                        Back
                      </Link>
                      <button className="btn btn-primary ml-2">
                        {edit ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <NotificationContainer />
      </div>
    );
  }
}

export default AddState;
